import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { updateCustomerByInstallationId } from '../../api/customer';
import { fetchInstallationById, installationStatusUpdate } from '../../api/installation';

const InstallationForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);
    const [form, setForm] = useState({});
    const [files, setFiles] = useState([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateCustomerByInstallationId(customer.customer.id, customer.customer);
            await installationStatusUpdate(id, 'Done');
            Swal.fire({
                icon: 'success',
                title: 'Installation Submitted!',
                confirmButtonText: 'OK'
            }).then(() => navigate('/installation/list'));
        } catch (err) {
            console.error('Error submitting installation:', err);
            alert('There was an error. Please try again.');
        }
    };

    useEffect(() => {
        const loadCustomer = async () => {
            try {
                const res = await fetchInstallationById(id);
                setCustomer(res.data.data);
            } catch (err) {
                console.error('Error loading customer:', err);
            }
        };
        loadCustomer();
    }, [id]);

    return (
        <div className="container">
            <h3 className="mb-4">New Installation</h3>

            {customer && (
                <Card className="mb-4">
                    <Card.Header className="bg-primary text-white">Customer Info</Card.Header>
                    <Card.Body>
                        <p><strong>Account Number:</strong> {customer.customer.accountNumber}</p>
                        <p><strong>Name:</strong> {customer.customer.firstName} {customer.customer.lastName}</p>
                        <p><strong>Address:</strong> {customer.customer.address}</p>
                        <p><strong>Contact:</strong> {customer.customer.mobile1 || customer.mobile2}</p>
                    </Card.Body>
                </Card>
            )}

            <Form onSubmit={handleSubmit}>
                <Tabs defaultActiveKey="meterService" className="mb-4">
                    <Tab eventKey="meterService" title="Meter Service Details">
                        <Card className="p-3">
                            <Row>
                                <Col md={4}><Form.Group><Form.Label>Meter Number</Form.Label><Form.Control name="meterNumber" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Serial Number</Form.Label><Form.Control name="serialNumber" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>ERC Seal Number</Form.Label><Form.Control name="ercSealNumber" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>MORE Seal Number</Form.Label><Form.Control name="moreSealNumber" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Meter Brand</Form.Label><Form.Control name="meterBrand" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Meter Tag</Form.Label><Form.Control name="meterTag" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>Meter Count</Form.Label><Form.Control name="meterCount" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Multiplier</Form.Label><Form.Control name="multiplier" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Metering Voltage</Form.Label><Form.Control name="meteringVoltage" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>Service Connection</Form.Label><Form.Control name="serviceConnection" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Initial Reading</Form.Label><Form.Control name="initialReading" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Date Installed</Form.Label><Form.Control type="date" name="dateInstalled" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                        </Card>
                    </Tab>

                    <Tab eventKey="transformerInfo" title="Transformer Info">
                        <Card className="p-3">
                            <Row>
                                <Col md={4}><Form.Group><Form.Label>Transformer Number</Form.Label><Form.Control name="transformerNumber" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Transformer Serial No</Form.Label><Form.Control name="transformerSerialNo" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Transformer Brand Name</Form.Label><Form.Control name="transformerBrandName" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>Transformer Ownership</Form.Label><Form.Control name="transformerOwnership" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Transformer KVA Rating</Form.Label><Form.Control name="transformerKvaRating" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>High Voltage</Form.Label><Form.Control name="highVoltage" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>Low Voltage</Form.Label><Form.Control name="lowVoltage" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Polarity</Form.Label><Form.Control name="polarity" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>% Impedance</Form.Label><Form.Control name="impedance" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>Tap Position</Form.Label><Form.Control name="tapPosition" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Date Installed</Form.Label><Form.Control type="date" name="transformerDateInstalled" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>Date Manufactured</Form.Label><Form.Control type="date" name="dateManufactured" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                        </Card>
                    </Tab>

                    <Tab eventKey="ctptInfo" title="CT/PT Info">
                        <Card className="p-3">
                            <Row>
                                <Col md={4}><Form.Group><Form.Label>CT Serial No</Form.Label><Form.Control name="ctSerialNo" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>CT Brand Name</Form.Label><Form.Control name="ctBrandName" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>CT Ratio</Form.Label><Form.Control name="ctRatio" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}><Form.Group><Form.Label>PT Serial No</Form.Label><Form.Control name="ptSerialNo" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>PT Brand Name</Form.Label><Form.Control name="ptBrandName" onChange={handleChange} /></Form.Group></Col>
                                <Col md={4}><Form.Group><Form.Label>PT Ratio</Form.Label><Form.Control name="ptRatio" onChange={handleChange} /></Form.Group></Col>
                            </Row>
                        </Card>
                    </Tab>

                    <Tab eventKey="attachments" title="Attachments">
                        <Card className="p-3 mb-4">
                            <Form.Group className="mb-3">
                                <Form.Label>Upload Files</Form.Label>
                                <Form.Control type="file" multiple onChange={handleFileChange} />
                            </Form.Group>
                            <Button variant="primary" type="submit">Submit Installation</Button>
                        </Card>
                    </Tab>
                </Tabs>
            </Form>
        </div>
    );
};

export default InstallationForm;
